import { createContext, useContext } from 'react';
import { CardContextValue } from './types';

export const CardContext = createContext<CardContextValue | null>(null);

export const useCard = () => {
  const context = useContext(CardContext);
  if (!context) {
    throw new Error('Card components must be used within Card.Root');
  }
  return context;
};
